export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6637.7a050d6e.jpg";